import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { usersBackend } from './users.backend';
import { UsersEffect } from './users.effect';
import { usersReducer } from './users.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('users', usersReducer),
    BackendModule.forFeature('users', usersBackend),
    EffectsModule.forFeature([UsersEffect]),
  ],
})
export class DatastoreUsersModule {}
